const StatusUtils = {
  "Adicionado ao SPC": "Adicionado ao SPC",
  "Confirmado pela Unidade": "Confirmado pela Unidade",
  "Removido do SPC": "Removido do SPC",
  "Com inconsistências": "Com inconsistências",
  "Aguardando Confirmação da Unidade": "Aguardando Confirmação da Unidade",
  "Cancelado": "Cancelado",
  "Não Processado": "Não Processado",
  "Pendente de Remoção do SPC": "Pendente de Remoção do SPC",
  "Processado pela CDL": "Processado pela CDL"
}

export default StatusUtils;
